module.exports = __webpack_public_path__ + "assets/images/pages/medipremium/icon-medipremium-1.png?c949c04c";